import React from 'react';
import {
  Copy,
  Flex,
  Heading,
  StackSpace,
  Stack,
  SvgInfo,
} from '@grubhubprod/gh-cookbook-react';
import { Tooltip } from 'src/components/Tooltip/Tooltip';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

type PageSectionTitleProps = {
  title: string;
  tooltipContent?: React.ReactNode;
  subtitle?: React.ReactNode;
  y?: StackSpace;
  headingVariant?: 'h3' | 'h4' | 'h5';
  subtitleY?: StackSpace;
};

export const PageSectionTitle: React.FC<PageSectionTitleProps> = ({
  title,
  tooltipContent,
  subtitle,
  headingVariant = 'h4',
  y = 'sm',
  subtitleY = 'x-sm',
}) => {
  const { isPhone } = useScreenSizes();

  const deviceX = isPhone ? 'none' : 'md';

  const heading = tooltipContent ? (
    <Flex alignItems="center">
      <Stack x="xxx-sm">
        <Heading variant={headingVariant}>{title}</Heading>
      </Stack>
      <Tooltip
        maxWidth="290px"
        roundedContainer
        content={<Copy variant="body">{tooltipContent}</Copy>}
        interactive
      >
        <Stack as="span">
          <SvgInfo aria-label={`${title} info`} size="20px" />
        </Stack>
      </Tooltip>
    </Flex>
  ) : (
    <Heading variant={headingVariant}>{title}</Heading>
  );

  return (
    <Stack y={y} x={deviceX}>
      {subtitle ? (
        <>
          <Stack y={subtitleY}>{heading}</Stack>
          <Copy variant="body">{subtitle}</Copy>
        </>
      ) : (
        heading
      )}
    </Stack>
  );
};
